import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		anim: false,
		ready: false,
	},
	actions: {
		changeAnim ({ commit }, status) {
			commit('change_anim', status)
		},
		ready ({ commit }) {
			commit('set_ready')
		}
	},
	mutations: {
		change_anim (state, status) {
			state.anim = status
		},
		set_ready (state) {
			state.ready = true
		}
	}
})

export default store;